import React from 'react'

export default function ConfidentialPolicyPage() {
  return (
    <div style={{paddingLeft : "10%", paddingRight : "10%"}}>

<head>

    <title>Politique de Confidentialité - MyJouleWay</title>
    <style>

    </style>
</head>
<body>
    <div >
        <h1>Politique de Confidentialité</h1>
        <p><strong>Date d'entrée en vigueur :</strong> 27/03/2025</p>

        <h2>1. Introduction</h2>
        <p>Bienvenue sur <strong>MyJouleWay</strong>. Votre confidentialité est une priorité. Cette politique explique notre approche en matière de données personnelles.</p>

        <h2>2. Aucune Collecte de Données</h2>
        <p>L'application MyJouleWay ne collecte, ne stocke ni ne partage aucune donnée personnelle des utilisateurs. Aucune information n'est enregistrée sur nos serveurs ou transmise à des tiers.</p>

        <h2>3. Permissions et Accès</h2>
        <p>Bien que certaines fonctionnalités puissent nécessiter des autorisations (ex. : accès au capteur de mouvement, connexion Bluetooth), ces accès sont strictement locaux et ne sont pas exploités à des fins de collecte de données.</p>

        <h2>4. Conformité au RGPD</h2>
        <p>Puisque nous ne stockons aucune donnée personnelle, nous respectons pleinement le <strong>Règlement Général sur la Protection des Données (RGPD)</strong>. Aucun droit d'accès, de rectification ou d'effacement des données n'est applicable.</p>

        <h2>5. Contact</h2>
        <p>Pour toute question concernant cette politique, vous pouvez nous contacter à : <a href="mailto:support@myjoulebox.com.com">support@myjouleway.com</a></p>
    </div>
</body>

    </div>
  )
}
